function qr(t, i = 0) {
  return t = typeof t == "string" ? parseFloat(t) : t, isNaN(t) ? (console.error("Authentic Core error: Invalid number (getting rounded number).", t), null) : i > 0 ? parseFloat(t.toFixed(i)) : Math.round(t);
}
function mn(t = 0, i = 1) {
  return Math.random() * (i - t) + t;
}
function ni() {
  return mn() < 0.5;
}
const Y = 16, Qn = 36, Cn = 4, qn = "e30=";
function ri(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function nr(t) {
  const i = t.replace(/[-_ ](.)/g, (o, s) => s.toUpperCase());
  return i.charAt(0).toLowerCase() + i.slice(1);
}
function rr(t, i = !1) {
  return t[i ? "toUpperCase" : "toLowerCase"]().replace(/([a-z])([A-Z])/g, "$1_$2").replace(/[- ]+/g, "_");
}
function ir(t) {
  return t.toLowerCase().replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_ ]+/g, "-");
}
function ii(t) {
  return t.toLowerCase().replace(/([a-z])([A-Z])/g, "$1$ $2").replace(/[-_]+/g, " ").replace(/\b\w/g, (i) => i.toUpperCase());
}
function ti(t) {
  return t.endsWith("y") ? t.substring(0, t.length - 1) + "ies" : t.endsWith("s") ? t + "es" : t + "s";
}
function ei(t, i) {
  if (t === 0)
    return !0;
  for (let o = t - 1; o >= 0; o--) {
    const s = i[o];
    if (s !== " " && s !== `
` && s !== "	")
      return s === ".";
  }
  return !1;
}
function oi(t, i = Cn) {
  return `${t.substring(0, i)}...${t.substring(t.length - i)}`;
}
function ai(t, i = Cn) {
  return t.substring(t.length - i);
}
function ui(t) {
  if (t.includes(" "))
    return t.split(" ").map((o) => o[0]).join("");
  let i = t.slice(0, 3);
  for (; /[aeiou]$/.test(i); )
    i += t[i.length];
  return i;
}
function $(t) {
  return typeof t == "object" && !Array.isArray(t) && t !== null;
}
function tr(t) {
  return Object.values(t).some(
    (i) => typeof i == "object" ? Array.isArray(i) ? i.length > 0 : i !== null ? tr(i) : !1 : typeof i == "string" ? i.length > 0 : typeof i < "u"
  );
}
function er(t, i, o = !1) {
  const s = Array.isArray(i) ? i : [i];
  for (const c of s)
    for (const [p, g] of Object.entries(c))
      $(t[p]) && $(g) ? t[p] = er(t[p], [g], o) : Array.isArray(t[p]) && Array.isArray(g) && o ? t[p] = [...t[p].filter((u) => !g.includes(u)), ...g] : t[p] = g;
  return { ...t };
}
function Mn(t, i) {
  if (Object.keys(t).length !== Object.keys(i).length)
    return !1;
  for (const o of Object.keys(t)) {
    const s = t[o], c = i[o];
    if ($(s) && $(c)) {
      if (!Mn(s, c))
        return !1;
    } else if (Array.isArray(s) && Array.isArray(c)) {
      if (!Un(s, c))
        return !1;
    } else if (s !== c)
      return !1;
  }
  return !0;
}
function fi(t, i) {
  var s;
  const o = [];
  for (const c of t) {
    const p = c[i];
    if (typeof p > "u")
      continue;
    const g = o.find(([u]) => u === p);
    typeof g > "u" ? o.push([p, 1]) : g[1]++;
  }
  return ((s = o.sort((c, p) => p[1] - c[1])[0]) == null ? void 0 : s[0]) ?? null;
}
function Un(t, i) {
  if (t.length !== i.length)
    return !1;
  for (let o = 0; o < t.length; o++) {
    const s = t[o], c = i[o];
    if ($(s) && $(c)) {
      if (!Mn(s, c))
        return !1;
    } else if (Array.isArray(s) && Array.isArray(c)) {
      if (!Un(s, c))
        return !1;
    } else if (s !== c)
      return !1;
  }
  return !0;
}
const or = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[ -~]+)")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[ -~]+))\])$/, ar = 45, ur = 10, fr = /^#[0-9A-Fa-f]{3,6}/, sr = /[@#$%^&*()_+~`|}{[\]:;?><,/-=\\0-9]/g, cr = 5, dr = 9, lr = 7, gr = 17;
function pr(t) {
  return Object.prototype.toString.call(t) === "[object Date]" && !isNaN(t.getTime());
}
function q(t) {
  return t.startsWith("http://") || t.startsWith("https://");
}
function si(t) {
  return or.test(t) && t.length <= ar;
}
function hr(t) {
  const i = t.toString().replaceAll("-", "").replaceAll(".", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");
  return !isNaN(parseInt(i)) && i.length === ur;
}
function hn(t) {
  return fr.test(t);
}
function ci(t) {
  return !sr.test(t) && t.trim().split(" ").length > 1;
}
function An(t) {
  return !isNaN(parseInt(t.toString())) && t.toString().length === cr;
}
function di(t) {
  if (t.toString().length !== dr)
    return !1;
  const i = t.toString().split("").map(Number);
  return (
    // @ts-expect-error - We verify the number of digits above.
    (3 * (i[0] + i[3] + i[6]) + // @ts-expect-error - ^
    7 * (i[1] + i[4] + i[7]) + // @ts-expect-error - ^
    1 * (i[2] + i[5] + i[8])) % 10 === 0
  );
}
function li(t) {
  return t.toString().length >= lr && t.toString().length <= gr;
}
const X = 1e3, H = 60, Ar = 60, _r = 24, Er = 31, xr = 365, Rr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], gi = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function pi(t = Date.now()) {
  let i = new Date(t);
  return pr(i) || (console.error(
    "Authentic Core error: Invalid date constructor (getting midnight date). Returning current date instead.",
    t
  ), i = /* @__PURE__ */ new Date()), i.setHours(0, 0, 0, 0), i;
}
function hi(t, i = Date.now()) {
  let o = new Date(i);
  return isNaN(o.getTime()) && (console.error(
    "Authentic Core error: Invalid date constructor (getting offset date). Returning current date instead.",
    i
  ), o = /* @__PURE__ */ new Date()), new Date(
    o.getFullYear() + (t.unit === "year" ? t.amount : 0),
    o.getMonth() + (t.unit === "month" ? t.amount : 0),
    o.getDate() + (t.unit === "day" ? t.amount : 0),
    0,
    0,
    0
  );
}
function Ai(t) {
  const i = t.getTimezoneOffset(), o = new Date(t.getTime() - i * H * X), s = Math.abs(Math.floor(i / H)).toString().padStart(2, "0"), c = Math.abs(i % H).toString().padStart(2, "0");
  return `${o.toISOString().slice(0, -1)}${i < 0 ? "+" : "-"}${s}:${c}`;
}
function _i(t, i = /* @__PURE__ */ new Date()) {
  return t.getFullYear() > i.getFullYear() || t.getFullYear() === i.getFullYear() && t.getMonth() > i.getMonth() || t.getFullYear() === i.getFullYear() && t.getMonth() === i.getMonth() && t.getDate() > i.getDate();
}
function Ei() {
  const t = (/* @__PURE__ */ new Date()).getHours();
  return t >= 18 ? "evening" : t >= 12 ? "afternoon" : "morning";
}
function xi(t, i = /* @__PURE__ */ new Date()) {
  const o = X * H * Ar * _r, s = o * Rr.length, c = o * Er, p = o * xr;
  function g({ amount: b, unit: E }) {
    return `${b} ${E}${b > 1 ? "s" : ""} ago`;
  }
  const u = i.getTime() - t.getTime();
  if (u >= 0)
    return u <= X * H ? "just now" : u <= o ? "today" : u <= o * 2 ? "yesterday" : u <= s ? g({ unit: "day", amount: Math.ceil(u / o) }) : u <= c ? g({ unit: "week", amount: Math.floor(u / s) }) : u <= p ? g({ unit: "month", amount: Math.floor(u / c) }) : g({ unit: "year", amount: Math.floor(u / p) });
  const h = Math.max(0, Math.floor(u / o));
  return `in ${h} day${h > 1 ? "s" : ""}`;
}
async function Ri(t = X) {
  await new Promise((i) => {
    setTimeout(i, t);
  });
}
const wi = [{ codes: ["US", "USA"], name: "United States of America" }], bi = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DC", name: "District of Columbia" },
  { code: "DE", name: "Delaware" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" }
];
function Ti(t) {
  const i = t.split(",").map((E) => E.trim()), o = !i.some(An), s = i.length === (o ? 5 : 6), c = i[0], p = (s ? i[1] : null) ?? null, g = i[s ? 2 : 1];
  let u = i[s ? 3 : 2], h = i[i.length - 2];
  o && ([u, h] = (u ?? "").split(" "));
  const b = i[i.length - 1];
  return typeof c > "u" || typeof g > "u" || typeof u > "u" || typeof h > "u" || !An(h) || typeof b > "u" ? null : {
    street: c,
    ...p !== null ? { unit: p } : {},
    city: g,
    state: u,
    zipCode: h,
    country: b
  };
}
const Ii = 10;
function yi(t, i = "month day, year") {
  return i.startsWith("mm") ? t.toLocaleDateString() : t.toLocaleString(void 0, {
    month: i.startsWith("mth") ? "short" : "long",
    day: "2-digit",
    year: i.startsWith("mth") ? void 0 : "numeric"
  });
}
function mi(t, i = !1) {
  const o = !i && typeof t.unit < "u" ? `, ${t.unit}` : "";
  return `${t.street}${o}, ${t.city}, ${t.state} ${t.zipCode}, ${t.country}`;
}
function Ci(t, i = !1, o = !1) {
  if (t = typeof t == "string" ? parseFloat(t) : t, isNaN(t))
    return console.error("Authentic Core error: Invalid currency value (formatting currency).", t), null;
  const s = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: i ? "compact" : void 0,
    compactDisplay: i ? "long" : void 0
  }).format(t);
  return o ? s : s.replace(".00", "");
}
function Mi(t) {
  return hr(t) ? t.toString().replace(/\D/g, "").replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3") : (console.error("Authentic Core error: Invalid phone number (formatting phone number).", t), null);
}
const wr = 16777216, F = 255, br = 299, Tr = 587, Ir = 114, yr = 1e3, mr = 0.65, Ui = "#000000", Oi = "#FFFFFF";
function K(t) {
  const [i, o, s] = (t.startsWith("#") ? k(t) : t).replace("rgb(", "").replace("rgba(", "").replace(")", "").replaceAll(" ", "").split(",").map((c) => parseInt(c));
  return typeof i > "u" || typeof o > "u" || typeof s > "u" ? (console.error("Authentic Core error: Invalid color (getting RGB values).", t), null) : [i, o, s];
}
function Cr(t) {
  const i = K(t);
  if (i === null)
    return console.error("Authentic Core error: Invalid color (getting color lightness).", t), -1;
  const [o, s, c] = i;
  return (o * br + s * Tr + c * Ir) / yr / F;
}
function L(t) {
  return Cr(t) < mr;
}
function Mr(t, i) {
  const o = K(t);
  if (o === null)
    return console.error("Authentic Core error: Invalid color (darkening color).", t), null;
  const [s, c, p] = o;
  return `rgb(${Math.max(0, s - s * i)}, ${Math.max(0, c - c * i)}, ${Math.max(0, p - p * i)})`;
}
function Ur(t, i) {
  const o = K(t);
  if (o === null)
    return console.error("Authentic Core error: Invalid color (darkening color).", t), null;
  const [s, c, p] = o;
  return `rgb(${Math.min(F, s + (F - s) * i)}, ${Math.min(
    F,
    c + (F - c) * i
  )}, ${Math.min(F, p + (F - p) * i)}`;
}
function Or(t) {
  const i = K(t);
  if (i === null)
    return console.error("Authentic Core error: Invalid RGB color (converting RGB color to hex).", t), null;
  const [o, s, c] = i;
  return `#${[o, s, c].map((p) => p.toString(Y).padStart(2, "0")).join("")}`;
}
function k(t, i = 1) {
  const o = t.replace("#", ""), s = parseInt(o.substring(0, 2), Y), c = parseInt(o.substring(2, 4), Y), p = parseInt(o.substring(4, 6), Y), g = i >= 0 && i < 1;
  return `rgb${g ? "a" : ""}(${s}, ${c}, ${p}${g ? `, ${i}` : ""})`;
}
function Ni() {
  return `#${Math.floor(Math.random() * wr).toString(Y)}`;
}
var _n = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, nn = {}, J = {};
J.byteLength = Dr;
J.toByteArray = Br;
J.fromByteArray = kr;
var N = [], M = [], Nr = typeof Uint8Array < "u" ? Uint8Array : Array, Q = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var B = 0, Lr = Q.length; B < Lr; ++B)
  N[B] = Q[B], M[Q.charCodeAt(B)] = B;
M["-".charCodeAt(0)] = 62;
M["_".charCodeAt(0)] = 63;
function On(t) {
  var i = t.length;
  if (i % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var o = t.indexOf("=");
  o === -1 && (o = i);
  var s = o === i ? 0 : 4 - o % 4;
  return [o, s];
}
function Dr(t) {
  var i = On(t), o = i[0], s = i[1];
  return (o + s) * 3 / 4 - s;
}
function Fr(t, i, o) {
  return (i + o) * 3 / 4 - o;
}
function Br(t) {
  var i, o = On(t), s = o[0], c = o[1], p = new Nr(Fr(t, s, c)), g = 0, u = c > 0 ? s - 4 : s, h;
  for (h = 0; h < u; h += 4)
    i = M[t.charCodeAt(h)] << 18 | M[t.charCodeAt(h + 1)] << 12 | M[t.charCodeAt(h + 2)] << 6 | M[t.charCodeAt(h + 3)], p[g++] = i >> 16 & 255, p[g++] = i >> 8 & 255, p[g++] = i & 255;
  return c === 2 && (i = M[t.charCodeAt(h)] << 2 | M[t.charCodeAt(h + 1)] >> 4, p[g++] = i & 255), c === 1 && (i = M[t.charCodeAt(h)] << 10 | M[t.charCodeAt(h + 1)] << 4 | M[t.charCodeAt(h + 2)] >> 2, p[g++] = i >> 8 & 255, p[g++] = i & 255), p;
}
function vr(t) {
  return N[t >> 18 & 63] + N[t >> 12 & 63] + N[t >> 6 & 63] + N[t & 63];
}
function $r(t, i, o) {
  for (var s, c = [], p = i; p < o; p += 3)
    s = (t[p] << 16 & 16711680) + (t[p + 1] << 8 & 65280) + (t[p + 2] & 255), c.push(vr(s));
  return c.join("");
}
function kr(t) {
  for (var i, o = t.length, s = o % 3, c = [], p = 16383, g = 0, u = o - s; g < u; g += p)
    c.push($r(t, g, g + p > u ? u : g + p));
  return s === 1 ? (i = t[o - 1], c.push(
    N[i >> 2] + N[i << 4 & 63] + "=="
  )) : s === 2 && (i = (t[o - 2] << 8) + t[o - 1], c.push(
    N[i >> 10] + N[i >> 4 & 63] + N[i << 2 & 63] + "="
  )), c.join("");
}
var rn = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
rn.read = function(t, i, o, s, c) {
  var p, g, u = c * 8 - s - 1, h = (1 << u) - 1, b = h >> 1, E = -7, T = o ? c - 1 : 0, U = o ? -1 : 1, m = t[i + T];
  for (T += U, p = m & (1 << -E) - 1, m >>= -E, E += u; E > 0; p = p * 256 + t[i + T], T += U, E -= 8)
    ;
  for (g = p & (1 << -E) - 1, p >>= -E, E += s; E > 0; g = g * 256 + t[i + T], T += U, E -= 8)
    ;
  if (p === 0)
    p = 1 - b;
  else {
    if (p === h)
      return g ? NaN : (m ? -1 : 1) * (1 / 0);
    g = g + Math.pow(2, s), p = p - b;
  }
  return (m ? -1 : 1) * g * Math.pow(2, p - s);
};
rn.write = function(t, i, o, s, c, p) {
  var g, u, h, b = p * 8 - c - 1, E = (1 << b) - 1, T = E >> 1, U = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, m = s ? 0 : p - 1, j = s ? 1 : -1, P = i < 0 || i === 0 && 1 / i < 0 ? 1 : 0;
  for (i = Math.abs(i), isNaN(i) || i === 1 / 0 ? (u = isNaN(i) ? 1 : 0, g = E) : (g = Math.floor(Math.log(i) / Math.LN2), i * (h = Math.pow(2, -g)) < 1 && (g--, h *= 2), g + T >= 1 ? i += U / h : i += U * Math.pow(2, 1 - T), i * h >= 2 && (g++, h /= 2), g + T >= E ? (u = 0, g = E) : g + T >= 1 ? (u = (i * h - 1) * Math.pow(2, c), g = g + T) : (u = i * Math.pow(2, T - 1) * Math.pow(2, c), g = 0)); c >= 8; t[o + m] = u & 255, m += j, u /= 256, c -= 8)
    ;
  for (g = g << c | u, b += c; b > 0; t[o + m] = g & 255, m += j, g /= 256, b -= 8)
    ;
  t[o + m - j] |= P * 128;
};
var jr = {}.toString, Yr = Array.isArray || function(t) {
  return jr.call(t) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
(function(t) {
  var i = J, o = rn, s = Yr;
  t.Buffer = u, t.SlowBuffer = Ln, t.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = _n.TYPED_ARRAY_SUPPORT !== void 0 ? _n.TYPED_ARRAY_SUPPORT : c(), t.kMaxLength = p();
  function c() {
    try {
      var e = new Uint8Array(1);
      return e.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
        return 42;
      } }, e.foo() === 42 && // typed array instances can be augmented
      typeof e.subarray == "function" && // chrome 9-10 lack `subarray`
      e.subarray(1, 1).byteLength === 0;
    } catch {
      return !1;
    }
  }
  function p() {
    return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function g(e, n) {
    if (p() < n)
      throw new RangeError("Invalid typed array length");
    return u.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(n), e.__proto__ = u.prototype) : (e === null && (e = new u(n)), e.length = n), e;
  }
  function u(e, n, r) {
    if (!u.TYPED_ARRAY_SUPPORT && !(this instanceof u))
      return new u(e, n, r);
    if (typeof e == "number") {
      if (typeof n == "string")
        throw new Error(
          "If encoding is specified then the first argument must be a string"
        );
      return T(this, e);
    }
    return h(this, e, n, r);
  }
  u.poolSize = 8192, u._augment = function(e) {
    return e.__proto__ = u.prototype, e;
  };
  function h(e, n, r, a) {
    if (typeof n == "number")
      throw new TypeError('"value" argument must not be a number');
    return typeof ArrayBuffer < "u" && n instanceof ArrayBuffer ? j(e, n, r, a) : typeof n == "string" ? U(e, n, r) : P(e, n);
  }
  u.from = function(e, n, r) {
    return h(null, e, n, r);
  }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
    value: null,
    configurable: !0
  }));
  function b(e) {
    if (typeof e != "number")
      throw new TypeError('"size" argument must be a number');
    if (e < 0)
      throw new RangeError('"size" argument must not be negative');
  }
  function E(e, n, r, a) {
    return b(n), n <= 0 ? g(e, n) : r !== void 0 ? typeof a == "string" ? g(e, n).fill(r, a) : g(e, n).fill(r) : g(e, n);
  }
  u.alloc = function(e, n, r) {
    return E(null, e, n, r);
  };
  function T(e, n) {
    if (b(n), e = g(e, n < 0 ? 0 : Z(n) | 0), !u.TYPED_ARRAY_SUPPORT)
      for (var r = 0; r < n; ++r)
        e[r] = 0;
    return e;
  }
  u.allocUnsafe = function(e) {
    return T(null, e);
  }, u.allocUnsafeSlow = function(e) {
    return T(null, e);
  };
  function U(e, n, r) {
    if ((typeof r != "string" || r === "") && (r = "utf8"), !u.isEncoding(r))
      throw new TypeError('"encoding" must be a valid string encoding');
    var a = tn(n, r) | 0;
    e = g(e, a);
    var f = e.write(n, r);
    return f !== a && (e = e.slice(0, f)), e;
  }
  function m(e, n) {
    var r = n.length < 0 ? 0 : Z(n.length) | 0;
    e = g(e, r);
    for (var a = 0; a < r; a += 1)
      e[a] = n[a] & 255;
    return e;
  }
  function j(e, n, r, a) {
    if (n.byteLength, r < 0 || n.byteLength < r)
      throw new RangeError("'offset' is out of bounds");
    if (n.byteLength < r + (a || 0))
      throw new RangeError("'length' is out of bounds");
    return r === void 0 && a === void 0 ? n = new Uint8Array(n) : a === void 0 ? n = new Uint8Array(n, r) : n = new Uint8Array(n, r, a), u.TYPED_ARRAY_SUPPORT ? (e = n, e.__proto__ = u.prototype) : e = m(e, n), e;
  }
  function P(e, n) {
    if (u.isBuffer(n)) {
      var r = Z(n.length) | 0;
      return e = g(e, r), e.length === 0 || n.copy(e, 0, 0, r), e;
    }
    if (n) {
      if (typeof ArrayBuffer < "u" && n.buffer instanceof ArrayBuffer || "length" in n)
        return typeof n.length != "number" || Zn(n.length) ? g(e, 0) : m(e, n);
      if (n.type === "Buffer" && s(n.data))
        return m(e, n.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
  }
  function Z(e) {
    if (e >= p())
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + p().toString(16) + " bytes");
    return e | 0;
  }
  function Ln(e) {
    return +e != e && (e = 0), u.alloc(+e);
  }
  u.isBuffer = function(n) {
    return !!(n != null && n._isBuffer);
  }, u.compare = function(n, r) {
    if (!u.isBuffer(n) || !u.isBuffer(r))
      throw new TypeError("Arguments must be Buffers");
    if (n === r)
      return 0;
    for (var a = n.length, f = r.length, d = 0, l = Math.min(a, f); d < l; ++d)
      if (n[d] !== r[d]) {
        a = n[d], f = r[d];
        break;
      }
    return a < f ? -1 : f < a ? 1 : 0;
  }, u.isEncoding = function(n) {
    switch (String(n).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(n, r) {
    if (!s(n))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (n.length === 0)
      return u.alloc(0);
    var a;
    if (r === void 0)
      for (r = 0, a = 0; a < n.length; ++a)
        r += n[a].length;
    var f = u.allocUnsafe(r), d = 0;
    for (a = 0; a < n.length; ++a) {
      var l = n[a];
      if (!u.isBuffer(l))
        throw new TypeError('"list" argument must be an Array of Buffers');
      l.copy(f, d), d += l.length;
    }
    return f;
  };
  function tn(e, n) {
    if (u.isBuffer(e))
      return e.length;
    if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
      return e.byteLength;
    typeof e != "string" && (e = "" + e);
    var r = e.length;
    if (r === 0)
      return 0;
    for (var a = !1; ; )
      switch (n) {
        case "ascii":
        case "latin1":
        case "binary":
          return r;
        case "utf8":
        case "utf-8":
        case void 0:
          return S(e).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return r * 2;
        case "hex":
          return r >>> 1;
        case "base64":
          return ln(e).length;
        default:
          if (a)
            return S(e).length;
          n = ("" + n).toLowerCase(), a = !0;
      }
  }
  u.byteLength = tn;
  function Dn(e, n, r) {
    var a = !1;
    if ((n === void 0 || n < 0) && (n = 0), n > this.length || ((r === void 0 || r > this.length) && (r = this.length), r <= 0) || (r >>>= 0, n >>>= 0, r <= n))
      return "";
    for (e || (e = "utf8"); ; )
      switch (e) {
        case "hex":
          return Gn(this, n, r);
        case "utf8":
        case "utf-8":
          return un(this, n, r);
        case "ascii":
          return Hn(this, n, r);
        case "latin1":
        case "binary":
          return Wn(this, n, r);
        case "base64":
          return jn(this, n, r);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Sn(this, n, r);
        default:
          if (a)
            throw new TypeError("Unknown encoding: " + e);
          e = (e + "").toLowerCase(), a = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function D(e, n, r) {
    var a = e[n];
    e[n] = e[r], e[r] = a;
  }
  u.prototype.swap16 = function() {
    var n = this.length;
    if (n % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var r = 0; r < n; r += 2)
      D(this, r, r + 1);
    return this;
  }, u.prototype.swap32 = function() {
    var n = this.length;
    if (n % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var r = 0; r < n; r += 4)
      D(this, r, r + 3), D(this, r + 1, r + 2);
    return this;
  }, u.prototype.swap64 = function() {
    var n = this.length;
    if (n % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var r = 0; r < n; r += 8)
      D(this, r, r + 7), D(this, r + 1, r + 6), D(this, r + 2, r + 5), D(this, r + 3, r + 4);
    return this;
  }, u.prototype.toString = function() {
    var n = this.length | 0;
    return n === 0 ? "" : arguments.length === 0 ? un(this, 0, n) : Dn.apply(this, arguments);
  }, u.prototype.equals = function(n) {
    if (!u.isBuffer(n))
      throw new TypeError("Argument must be a Buffer");
    return this === n ? !0 : u.compare(this, n) === 0;
  }, u.prototype.inspect = function() {
    var n = "", r = t.INSPECT_MAX_BYTES;
    return this.length > 0 && (n = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (n += " ... ")), "<Buffer " + n + ">";
  }, u.prototype.compare = function(n, r, a, f, d) {
    if (!u.isBuffer(n))
      throw new TypeError("Argument must be a Buffer");
    if (r === void 0 && (r = 0), a === void 0 && (a = n ? n.length : 0), f === void 0 && (f = 0), d === void 0 && (d = this.length), r < 0 || a > n.length || f < 0 || d > this.length)
      throw new RangeError("out of range index");
    if (f >= d && r >= a)
      return 0;
    if (f >= d)
      return -1;
    if (r >= a)
      return 1;
    if (r >>>= 0, a >>>= 0, f >>>= 0, d >>>= 0, this === n)
      return 0;
    for (var l = d - f, A = a - r, _ = Math.min(l, A), x = this.slice(f, d), y = n.slice(r, a), R = 0; R < _; ++R)
      if (x[R] !== y[R]) {
        l = x[R], A = y[R];
        break;
      }
    return l < A ? -1 : A < l ? 1 : 0;
  };
  function en(e, n, r, a, f) {
    if (e.length === 0)
      return -1;
    if (typeof r == "string" ? (a = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = f ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
      if (f)
        return -1;
      r = e.length - 1;
    } else if (r < 0)
      if (f)
        r = 0;
      else
        return -1;
    if (typeof n == "string" && (n = u.from(n, a)), u.isBuffer(n))
      return n.length === 0 ? -1 : on(e, n, r, a, f);
    if (typeof n == "number")
      return n = n & 255, u.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? f ? Uint8Array.prototype.indexOf.call(e, n, r) : Uint8Array.prototype.lastIndexOf.call(e, n, r) : on(e, [n], r, a, f);
    throw new TypeError("val must be string, number or Buffer");
  }
  function on(e, n, r, a, f) {
    var d = 1, l = e.length, A = n.length;
    if (a !== void 0 && (a = String(a).toLowerCase(), a === "ucs2" || a === "ucs-2" || a === "utf16le" || a === "utf-16le")) {
      if (e.length < 2 || n.length < 2)
        return -1;
      d = 2, l /= 2, A /= 2, r /= 2;
    }
    function _(gn, pn) {
      return d === 1 ? gn[pn] : gn.readUInt16BE(pn * d);
    }
    var x;
    if (f) {
      var y = -1;
      for (x = r; x < l; x++)
        if (_(e, x) === _(n, y === -1 ? 0 : x - y)) {
          if (y === -1 && (y = x), x - y + 1 === A)
            return y * d;
        } else
          y !== -1 && (x -= x - y), y = -1;
    } else
      for (r + A > l && (r = l - A), x = r; x >= 0; x--) {
        for (var R = !0, V = 0; V < A; V++)
          if (_(e, x + V) !== _(n, V)) {
            R = !1;
            break;
          }
        if (R)
          return x;
      }
    return -1;
  }
  u.prototype.includes = function(n, r, a) {
    return this.indexOf(n, r, a) !== -1;
  }, u.prototype.indexOf = function(n, r, a) {
    return en(this, n, r, a, !0);
  }, u.prototype.lastIndexOf = function(n, r, a) {
    return en(this, n, r, a, !1);
  };
  function Fn(e, n, r, a) {
    r = Number(r) || 0;
    var f = e.length - r;
    a ? (a = Number(a), a > f && (a = f)) : a = f;
    var d = n.length;
    if (d % 2 !== 0)
      throw new TypeError("Invalid hex string");
    a > d / 2 && (a = d / 2);
    for (var l = 0; l < a; ++l) {
      var A = parseInt(n.substr(l * 2, 2), 16);
      if (isNaN(A))
        return l;
      e[r + l] = A;
    }
    return l;
  }
  function Bn(e, n, r, a) {
    return z(S(n, e.length - r), e, r, a);
  }
  function an(e, n, r, a) {
    return z(Jn(n), e, r, a);
  }
  function vn(e, n, r, a) {
    return an(e, n, r, a);
  }
  function $n(e, n, r, a) {
    return z(ln(n), e, r, a);
  }
  function kn(e, n, r, a) {
    return z(Pn(n, e.length - r), e, r, a);
  }
  u.prototype.write = function(n, r, a, f) {
    if (r === void 0)
      f = "utf8", a = this.length, r = 0;
    else if (a === void 0 && typeof r == "string")
      f = r, a = this.length, r = 0;
    else if (isFinite(r))
      r = r | 0, isFinite(a) ? (a = a | 0, f === void 0 && (f = "utf8")) : (f = a, a = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var d = this.length - r;
    if ((a === void 0 || a > d) && (a = d), n.length > 0 && (a < 0 || r < 0) || r > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    f || (f = "utf8");
    for (var l = !1; ; )
      switch (f) {
        case "hex":
          return Fn(this, n, r, a);
        case "utf8":
        case "utf-8":
          return Bn(this, n, r, a);
        case "ascii":
          return an(this, n, r, a);
        case "latin1":
        case "binary":
          return vn(this, n, r, a);
        case "base64":
          return $n(this, n, r, a);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return kn(this, n, r, a);
        default:
          if (l)
            throw new TypeError("Unknown encoding: " + f);
          f = ("" + f).toLowerCase(), l = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function jn(e, n, r) {
    return n === 0 && r === e.length ? i.fromByteArray(e) : i.fromByteArray(e.slice(n, r));
  }
  function un(e, n, r) {
    r = Math.min(e.length, r);
    for (var a = [], f = n; f < r; ) {
      var d = e[f], l = null, A = d > 239 ? 4 : d > 223 ? 3 : d > 191 ? 2 : 1;
      if (f + A <= r) {
        var _, x, y, R;
        switch (A) {
          case 1:
            d < 128 && (l = d);
            break;
          case 2:
            _ = e[f + 1], (_ & 192) === 128 && (R = (d & 31) << 6 | _ & 63, R > 127 && (l = R));
            break;
          case 3:
            _ = e[f + 1], x = e[f + 2], (_ & 192) === 128 && (x & 192) === 128 && (R = (d & 15) << 12 | (_ & 63) << 6 | x & 63, R > 2047 && (R < 55296 || R > 57343) && (l = R));
            break;
          case 4:
            _ = e[f + 1], x = e[f + 2], y = e[f + 3], (_ & 192) === 128 && (x & 192) === 128 && (y & 192) === 128 && (R = (d & 15) << 18 | (_ & 63) << 12 | (x & 63) << 6 | y & 63, R > 65535 && R < 1114112 && (l = R));
        }
      }
      l === null ? (l = 65533, A = 1) : l > 65535 && (l -= 65536, a.push(l >>> 10 & 1023 | 55296), l = 56320 | l & 1023), a.push(l), f += A;
    }
    return Yn(a);
  }
  var fn = 4096;
  function Yn(e) {
    var n = e.length;
    if (n <= fn)
      return String.fromCharCode.apply(String, e);
    for (var r = "", a = 0; a < n; )
      r += String.fromCharCode.apply(
        String,
        e.slice(a, a += fn)
      );
    return r;
  }
  function Hn(e, n, r) {
    var a = "";
    r = Math.min(e.length, r);
    for (var f = n; f < r; ++f)
      a += String.fromCharCode(e[f] & 127);
    return a;
  }
  function Wn(e, n, r) {
    var a = "";
    r = Math.min(e.length, r);
    for (var f = n; f < r; ++f)
      a += String.fromCharCode(e[f]);
    return a;
  }
  function Gn(e, n, r) {
    var a = e.length;
    (!n || n < 0) && (n = 0), (!r || r < 0 || r > a) && (r = a);
    for (var f = "", d = n; d < r; ++d)
      f += Kn(e[d]);
    return f;
  }
  function Sn(e, n, r) {
    for (var a = e.slice(n, r), f = "", d = 0; d < a.length; d += 2)
      f += String.fromCharCode(a[d] + a[d + 1] * 256);
    return f;
  }
  u.prototype.slice = function(n, r) {
    var a = this.length;
    n = ~~n, r = r === void 0 ? a : ~~r, n < 0 ? (n += a, n < 0 && (n = 0)) : n > a && (n = a), r < 0 ? (r += a, r < 0 && (r = 0)) : r > a && (r = a), r < n && (r = n);
    var f;
    if (u.TYPED_ARRAY_SUPPORT)
      f = this.subarray(n, r), f.__proto__ = u.prototype;
    else {
      var d = r - n;
      f = new u(d, void 0);
      for (var l = 0; l < d; ++l)
        f[l] = this[l + n];
    }
    return f;
  };
  function I(e, n, r) {
    if (e % 1 !== 0 || e < 0)
      throw new RangeError("offset is not uint");
    if (e + n > r)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUIntLE = function(n, r, a) {
    n = n | 0, r = r | 0, a || I(n, r, this.length);
    for (var f = this[n], d = 1, l = 0; ++l < r && (d *= 256); )
      f += this[n + l] * d;
    return f;
  }, u.prototype.readUIntBE = function(n, r, a) {
    n = n | 0, r = r | 0, a || I(n, r, this.length);
    for (var f = this[n + --r], d = 1; r > 0 && (d *= 256); )
      f += this[n + --r] * d;
    return f;
  }, u.prototype.readUInt8 = function(n, r) {
    return r || I(n, 1, this.length), this[n];
  }, u.prototype.readUInt16LE = function(n, r) {
    return r || I(n, 2, this.length), this[n] | this[n + 1] << 8;
  }, u.prototype.readUInt16BE = function(n, r) {
    return r || I(n, 2, this.length), this[n] << 8 | this[n + 1];
  }, u.prototype.readUInt32LE = function(n, r) {
    return r || I(n, 4, this.length), (this[n] | this[n + 1] << 8 | this[n + 2] << 16) + this[n + 3] * 16777216;
  }, u.prototype.readUInt32BE = function(n, r) {
    return r || I(n, 4, this.length), this[n] * 16777216 + (this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3]);
  }, u.prototype.readIntLE = function(n, r, a) {
    n = n | 0, r = r | 0, a || I(n, r, this.length);
    for (var f = this[n], d = 1, l = 0; ++l < r && (d *= 256); )
      f += this[n + l] * d;
    return d *= 128, f >= d && (f -= Math.pow(2, 8 * r)), f;
  }, u.prototype.readIntBE = function(n, r, a) {
    n = n | 0, r = r | 0, a || I(n, r, this.length);
    for (var f = r, d = 1, l = this[n + --f]; f > 0 && (d *= 256); )
      l += this[n + --f] * d;
    return d *= 128, l >= d && (l -= Math.pow(2, 8 * r)), l;
  }, u.prototype.readInt8 = function(n, r) {
    return r || I(n, 1, this.length), this[n] & 128 ? (255 - this[n] + 1) * -1 : this[n];
  }, u.prototype.readInt16LE = function(n, r) {
    r || I(n, 2, this.length);
    var a = this[n] | this[n + 1] << 8;
    return a & 32768 ? a | 4294901760 : a;
  }, u.prototype.readInt16BE = function(n, r) {
    r || I(n, 2, this.length);
    var a = this[n + 1] | this[n] << 8;
    return a & 32768 ? a | 4294901760 : a;
  }, u.prototype.readInt32LE = function(n, r) {
    return r || I(n, 4, this.length), this[n] | this[n + 1] << 8 | this[n + 2] << 16 | this[n + 3] << 24;
  }, u.prototype.readInt32BE = function(n, r) {
    return r || I(n, 4, this.length), this[n] << 24 | this[n + 1] << 16 | this[n + 2] << 8 | this[n + 3];
  }, u.prototype.readFloatLE = function(n, r) {
    return r || I(n, 4, this.length), o.read(this, n, !0, 23, 4);
  }, u.prototype.readFloatBE = function(n, r) {
    return r || I(n, 4, this.length), o.read(this, n, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(n, r) {
    return r || I(n, 8, this.length), o.read(this, n, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(n, r) {
    return r || I(n, 8, this.length), o.read(this, n, !1, 52, 8);
  };
  function C(e, n, r, a, f, d) {
    if (!u.isBuffer(e))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (n > f || n < d)
      throw new RangeError('"value" argument is out of bounds');
    if (r + a > e.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUIntLE = function(n, r, a, f) {
    if (n = +n, r = r | 0, a = a | 0, !f) {
      var d = Math.pow(2, 8 * a) - 1;
      C(this, n, r, a, d, 0);
    }
    var l = 1, A = 0;
    for (this[r] = n & 255; ++A < a && (l *= 256); )
      this[r + A] = n / l & 255;
    return r + a;
  }, u.prototype.writeUIntBE = function(n, r, a, f) {
    if (n = +n, r = r | 0, a = a | 0, !f) {
      var d = Math.pow(2, 8 * a) - 1;
      C(this, n, r, a, d, 0);
    }
    var l = a - 1, A = 1;
    for (this[r + l] = n & 255; --l >= 0 && (A *= 256); )
      this[r + l] = n / A & 255;
    return r + a;
  }, u.prototype.writeUInt8 = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (n = Math.floor(n)), this[r] = n & 255, r + 1;
  };
  function W(e, n, r, a) {
    n < 0 && (n = 65535 + n + 1);
    for (var f = 0, d = Math.min(e.length - r, 2); f < d; ++f)
      e[r + f] = (n & 255 << 8 * (a ? f : 1 - f)) >>> (a ? f : 1 - f) * 8;
  }
  u.prototype.writeUInt16LE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = n & 255, this[r + 1] = n >>> 8) : W(this, n, r, !0), r + 2;
  }, u.prototype.writeUInt16BE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = n >>> 8, this[r + 1] = n & 255) : W(this, n, r, !1), r + 2;
  };
  function G(e, n, r, a) {
    n < 0 && (n = 4294967295 + n + 1);
    for (var f = 0, d = Math.min(e.length - r, 4); f < d; ++f)
      e[r + f] = n >>> (a ? f : 3 - f) * 8 & 255;
  }
  u.prototype.writeUInt32LE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r + 3] = n >>> 24, this[r + 2] = n >>> 16, this[r + 1] = n >>> 8, this[r] = n & 255) : G(this, n, r, !0), r + 4;
  }, u.prototype.writeUInt32BE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = n >>> 24, this[r + 1] = n >>> 16, this[r + 2] = n >>> 8, this[r + 3] = n & 255) : G(this, n, r, !1), r + 4;
  }, u.prototype.writeIntLE = function(n, r, a, f) {
    if (n = +n, r = r | 0, !f) {
      var d = Math.pow(2, 8 * a - 1);
      C(this, n, r, a, d - 1, -d);
    }
    var l = 0, A = 1, _ = 0;
    for (this[r] = n & 255; ++l < a && (A *= 256); )
      n < 0 && _ === 0 && this[r + l - 1] !== 0 && (_ = 1), this[r + l] = (n / A >> 0) - _ & 255;
    return r + a;
  }, u.prototype.writeIntBE = function(n, r, a, f) {
    if (n = +n, r = r | 0, !f) {
      var d = Math.pow(2, 8 * a - 1);
      C(this, n, r, a, d - 1, -d);
    }
    var l = a - 1, A = 1, _ = 0;
    for (this[r + l] = n & 255; --l >= 0 && (A *= 256); )
      n < 0 && _ === 0 && this[r + l + 1] !== 0 && (_ = 1), this[r + l] = (n / A >> 0) - _ & 255;
    return r + a;
  }, u.prototype.writeInt8 = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (n = Math.floor(n)), n < 0 && (n = 255 + n + 1), this[r] = n & 255, r + 1;
  }, u.prototype.writeInt16LE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r] = n & 255, this[r + 1] = n >>> 8) : W(this, n, r, !0), r + 2;
  }, u.prototype.writeInt16BE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r] = n >>> 8, this[r + 1] = n & 255) : W(this, n, r, !1), r + 2;
  }, u.prototype.writeInt32LE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[r] = n & 255, this[r + 1] = n >>> 8, this[r + 2] = n >>> 16, this[r + 3] = n >>> 24) : G(this, n, r, !0), r + 4;
  }, u.prototype.writeInt32BE = function(n, r, a) {
    return n = +n, r = r | 0, a || C(this, n, r, 4, 2147483647, -2147483648), n < 0 && (n = 4294967295 + n + 1), u.TYPED_ARRAY_SUPPORT ? (this[r] = n >>> 24, this[r + 1] = n >>> 16, this[r + 2] = n >>> 8, this[r + 3] = n & 255) : G(this, n, r, !1), r + 4;
  };
  function sn(e, n, r, a, f, d) {
    if (r + a > e.length)
      throw new RangeError("Index out of range");
    if (r < 0)
      throw new RangeError("Index out of range");
  }
  function cn(e, n, r, a, f) {
    return f || sn(e, n, r, 4), o.write(e, n, r, a, 23, 4), r + 4;
  }
  u.prototype.writeFloatLE = function(n, r, a) {
    return cn(this, n, r, !0, a);
  }, u.prototype.writeFloatBE = function(n, r, a) {
    return cn(this, n, r, !1, a);
  };
  function dn(e, n, r, a, f) {
    return f || sn(e, n, r, 8), o.write(e, n, r, a, 52, 8), r + 8;
  }
  u.prototype.writeDoubleLE = function(n, r, a) {
    return dn(this, n, r, !0, a);
  }, u.prototype.writeDoubleBE = function(n, r, a) {
    return dn(this, n, r, !1, a);
  }, u.prototype.copy = function(n, r, a, f) {
    if (a || (a = 0), !f && f !== 0 && (f = this.length), r >= n.length && (r = n.length), r || (r = 0), f > 0 && f < a && (f = a), f === a || n.length === 0 || this.length === 0)
      return 0;
    if (r < 0)
      throw new RangeError("targetStart out of bounds");
    if (a < 0 || a >= this.length)
      throw new RangeError("sourceStart out of bounds");
    if (f < 0)
      throw new RangeError("sourceEnd out of bounds");
    f > this.length && (f = this.length), n.length - r < f - a && (f = n.length - r + a);
    var d = f - a, l;
    if (this === n && a < r && r < f)
      for (l = d - 1; l >= 0; --l)
        n[l + r] = this[l + a];
    else if (d < 1e3 || !u.TYPED_ARRAY_SUPPORT)
      for (l = 0; l < d; ++l)
        n[l + r] = this[l + a];
    else
      Uint8Array.prototype.set.call(
        n,
        this.subarray(a, a + d),
        r
      );
    return d;
  }, u.prototype.fill = function(n, r, a, f) {
    if (typeof n == "string") {
      if (typeof r == "string" ? (f = r, r = 0, a = this.length) : typeof a == "string" && (f = a, a = this.length), n.length === 1) {
        var d = n.charCodeAt(0);
        d < 256 && (n = d);
      }
      if (f !== void 0 && typeof f != "string")
        throw new TypeError("encoding must be a string");
      if (typeof f == "string" && !u.isEncoding(f))
        throw new TypeError("Unknown encoding: " + f);
    } else
      typeof n == "number" && (n = n & 255);
    if (r < 0 || this.length < r || this.length < a)
      throw new RangeError("Out of range index");
    if (a <= r)
      return this;
    r = r >>> 0, a = a === void 0 ? this.length : a >>> 0, n || (n = 0);
    var l;
    if (typeof n == "number")
      for (l = r; l < a; ++l)
        this[l] = n;
    else {
      var A = u.isBuffer(n) ? n : S(new u(n, f).toString()), _ = A.length;
      for (l = 0; l < a - r; ++l)
        this[l + r] = A[l % _];
    }
    return this;
  };
  var zn = /[^+\/0-9A-Za-z-_]/g;
  function Vn(e) {
    if (e = Xn(e).replace(zn, ""), e.length < 2)
      return "";
    for (; e.length % 4 !== 0; )
      e = e + "=";
    return e;
  }
  function Xn(e) {
    return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
  }
  function Kn(e) {
    return e < 16 ? "0" + e.toString(16) : e.toString(16);
  }
  function S(e, n) {
    n = n || 1 / 0;
    for (var r, a = e.length, f = null, d = [], l = 0; l < a; ++l) {
      if (r = e.charCodeAt(l), r > 55295 && r < 57344) {
        if (!f) {
          if (r > 56319) {
            (n -= 3) > -1 && d.push(239, 191, 189);
            continue;
          } else if (l + 1 === a) {
            (n -= 3) > -1 && d.push(239, 191, 189);
            continue;
          }
          f = r;
          continue;
        }
        if (r < 56320) {
          (n -= 3) > -1 && d.push(239, 191, 189), f = r;
          continue;
        }
        r = (f - 55296 << 10 | r - 56320) + 65536;
      } else
        f && (n -= 3) > -1 && d.push(239, 191, 189);
      if (f = null, r < 128) {
        if ((n -= 1) < 0)
          break;
        d.push(r);
      } else if (r < 2048) {
        if ((n -= 2) < 0)
          break;
        d.push(
          r >> 6 | 192,
          r & 63 | 128
        );
      } else if (r < 65536) {
        if ((n -= 3) < 0)
          break;
        d.push(
          r >> 12 | 224,
          r >> 6 & 63 | 128,
          r & 63 | 128
        );
      } else if (r < 1114112) {
        if ((n -= 4) < 0)
          break;
        d.push(
          r >> 18 | 240,
          r >> 12 & 63 | 128,
          r >> 6 & 63 | 128,
          r & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return d;
  }
  function Jn(e) {
    for (var n = [], r = 0; r < e.length; ++r)
      n.push(e.charCodeAt(r) & 255);
    return n;
  }
  function Pn(e, n) {
    for (var r, a, f, d = [], l = 0; l < e.length && !((n -= 2) < 0); ++l)
      r = e.charCodeAt(l), a = r >> 8, f = r % 256, d.push(f), d.push(a);
    return d;
  }
  function ln(e) {
    return i.toByteArray(Vn(e));
  }
  function z(e, n, r, a) {
    for (var f = 0; f < a && !(f + r >= n.length || f >= e.length); ++f)
      n[f + r] = e[f];
    return f;
  }
  function Zn(e) {
    return e !== e;
  }
})(nn);
const Hr = "%22", Li = "utm_source", Di = "utm_medium", Fi = "utm_campaign", Bi = "utm_content";
function vi(t, i) {
  if (typeof window > "u" && typeof i > "u")
    return console.error("Authentic Core error: Must provide a URL if not in a browser (getting URL param).", t), null;
  const o = decodeURI(i ?? window.location.href).replaceAll(Hr, "");
  if (!q(o))
    return console.error("Authentic Core error: Invalid URL (getting URL param).", o), null;
  const s = o.split("?")[1];
  if (typeof s > "u")
    return null;
  const c = s.split("&").map((h) => h.split("="));
  function p(h) {
    var E;
    const b = (E = c.find((T) => {
      const U = T[0];
      return typeof U < "u" && [
        h,
        nr(h),
        rr(h),
        ir(h),
        h.replaceAll("_", ""),
        h.replaceAll("-", "")
      ].includes(U);
    })) == null ? void 0 : E[1];
    return (typeof b < "u" && b.length > 0 ? b : null) ?? null;
  }
  let g = null;
  if (Array.isArray(t)) {
    for (const h of t)
      if (g = p(h), g !== null)
        break;
  } else
    g = p(t);
  if (g === null)
    return null;
  let u = g;
  try {
    if (g.length < qn.length)
      throw new Error();
    u = JSON.parse(nn.Buffer.from(g, "base64").toString("binary"));
  } catch {
    try {
      u = JSON.parse(g);
    } catch {
    }
  }
  return u;
}
function Nn(t, i) {
  if (typeof window > "u" && typeof i > "u")
    return console.error("Authentic Core error: Must provide a URL if not in a browser (setting URL params).", t), null;
  let o = decodeURI(i ?? window.location.href);
  if (!q(o))
    return console.error("Authentic Core error: Invalid URL (setting URL params).", o), null;
  if (o = Wr(Object.keys(t), o) ?? "", o.length === 0)
    return console.error("Authentic Core error: Unable to remove duplicate URL params (setting URL params).", t), null;
  const s = Object.entries(t).map(
    ([c, p]) => `${c}=${typeof p == "object" ? nn.Buffer.from(JSON.stringify(p), "binary").toString("base64") : p}`
  );
  return o = `${o}${o.includes("?") ? "&" : "?"}${s.join("&")}`, typeof window < "u" && typeof i > "u" && window.history.replaceState(null, "", o), o;
}
function Wr(t, i) {
  if (typeof window > "u" && typeof i > "u")
    return console.error("Authentic Core error: Must provide a URL if not in a browser (removing URL params).", t), null;
  let o = decodeURI(i ?? window.location.href);
  if (!q(o))
    return console.error("Authentic Core error: Invalid URL (removing URL params).", o), null;
  const s = o.split("?")[0] ?? o, c = o.split("?")[1];
  if (typeof c > "u")
    return s;
  const p = c.split("&").filter((g) => {
    const u = g.split("=")[0];
    return typeof u < "u" && !t.includes(u);
  });
  return o = p.length > 0 ? `${s}?${p.join("&")}` : s, typeof window < "u" && typeof i > "u" && window.history.replaceState(null, "", o), o;
}
function $i(t, i) {
  let o = !1, s = i.target;
  for (; !o && s.parentElement !== null; ) {
    if (s === t) {
      o = !0;
      break;
    }
    s = s.parentElement;
  }
  return o;
}
function ki(t) {
  const i = t.nodeName.toLowerCase();
  return i === "p" || i[0] === "h" && !isNaN(parseInt(i[1] ?? ""));
}
function ji(t = "element") {
  function i() {
    return `${t}-${mn().toString(Qn).replace("0.", "")}`;
  }
  let o = i();
  if (typeof window > "u")
    return o;
  for (; document.getElementById(o) !== null; )
    o = i();
  return o;
}
function Yi(t) {
  function i() {
    return typeof window > "u" ? null : window[`${t}Storage`];
  }
  return {
    getItem: (o) => {
      try {
        const s = i();
        return s === null ? null : s.getItem(o);
      } catch (s) {
        return console.error(`Authentic Core error: Unable to get ${t} storage.`, s), null;
      }
    },
    setItem: (o, s) => {
      try {
        const c = i();
        return c === null ? !0 : (c.setItem(o, s), !1);
      } catch (c) {
        return console.error(`Authentic Core error: Unable to set ${t} storage.`, c), !0;
      }
    },
    removeItem: (o) => {
      try {
        const s = i();
        return s === null ? !0 : (s.removeItem(o), !1);
      } catch (s) {
        return console.error(`Authentic Core error: Unable to remove ${t} storage.`, s), !0;
      }
    }
  };
}
async function Hi(t) {
  return await new Promise((i) => {
    const o = new FileReader();
    o.onload = () => {
      o.result === null || typeof o.result != "string" ? (console.error("Authentic Core error: Unable to read file (converting to base64).", t.name), i(null)) : i(o.result.split("base64,")[1] ?? null);
    }, o.readAsDataURL(t);
  });
}
var Gr = /* @__PURE__ */ ((t) => (t.STAGING = "staging", t.SANDBOX = "sandbox", t.PRODUCTION = "prod", t))(Gr || {});
const Sr = "Authentic", Wi = "Authentic Services, Inc.", Gi = 20619648, v = "https://authenticinsurance.com", Si = "https://partner.authenticinsurance.com", zi = "https://blog.authenticinsurance.com", Vi = "https://github.com/authenticins", Xi = "https://authentic.gitbook.io", Ki = "https://twitter.com/authcaptives", Ji = "https://jobs.ashbyhq.com/authenticins", Pi = "https://calendly.com/mike-authenticins", Zi = "https://calendly.com/insurance--agent/chat-with-insurance-agent", Qi = "https://www.wh-app.io/authentic/workerscomp", qi = `${v}/docs/authentic-terms-of-service.pdf`, nt = `${v}/docs/authentic-privacy-policy.pdf`, rt = "sales@authenticins.com", it = "support@authenticins.com", tt = 4092190592, et = "claim+authentic@reserv.com", ot = 6467591705, w = {
  authenticRed: "#D5422F",
  black: "#181819",
  offBlack: "#242424",
  darkGray: "#323232",
  gray: "#8A8A8A",
  lightGray: "#E4E4E4",
  offWhite: "#F7F6F7",
  white: "#FFFFFF",
  red: "#9B1D0C",
  yellow: "#E9AC4F",
  green: "#75A45F",
  blue: "#5A77A4"
}, zr = 0.5, En = 0.85, O = {
  isDarkMode: !1,
  palette: {
    primary: w.authenticRed,
    doesPrimaryPassAccessibility: !0,
    primaryContrast: w.white,
    // Authentic doesn't have a secondary brand color.
    secondary: w.authenticRed,
    doesSecondaryPassAccessibility: !0,
    secondaryContrast: w.white,
    background: w.offWhite,
    text: w.offBlack,
    muted: w.gray,
    subtle: w.lightGray,
    surface: w.white,
    error: w.red,
    warning: w.yellow,
    success: w.green,
    neutral: w.blue
  },
  baseSpacingPx: 8,
  font: {
    family: {
      display: "Archivo-Black, sans-serif",
      heading: "Gilroy, sans-serif",
      base: "Proxima-Nova, sans-serif"
    },
    lineHeight: {
      display: 1.1,
      heading: 1.1,
      base: 1.3
    },
    sizePx: {
      sm: 12,
      base: 16,
      lg: 20,
      xl: 24,
      xxl: 48,
      xxxl: 64
    }
  },
  border: {
    baseWidthPx: 1,
    radiusPx: {
      sm: 2,
      base: 4,
      lg: 12,
      full: 100
    }
  },
  get shadow() {
    return {
      drop: "rgba(0, 0, 0, 0.1) 0px 6px 16px",
      focus: `${k(this.palette.primary, this.opacity.subtle)} 0 0 0 ${this.border.baseWidthPx * 2}px`
    };
  },
  opacity: {
    hidden: 0,
    subtle: 0.2,
    disabled: 0.6,
    loading: 0.85
  },
  transition: {
    baseDurationMs: 175,
    timingFunction: "cubic-bezier(0.42, 0, 0.58, 1)"
  },
  view: { maxContentWidthPx: 1500 },
  element: {
    maxWidthPx: 450,
    maxSizeViewportUnits: 95,
    maxBorderRadiusPx: 26,
    zIndex: {
      dropdown: 990,
      tooltip: 999,
      navigation: 9990,
      modal: 9999,
      widget: 99999
    }
  },
  breakpoints: {
    mobile: {
      px: 950,
      isBroken: !1
    }
  },
  brand: {
    name: Sr,
    logoUrls: {
      darkBg: `${v}/img/authentic/logo/horizontal/horizontal-color-darkbg.png`,
      lightBg: `${v}/img/authentic/logo/horizontal/horizontal-color-lightbg.png`
    },
    faviconUrl: `${v}/favicon.ico`
  }
}, xn = 4, Rn = 6, wn = 3, bn = 3, Tn = 2, at = 0.75, In = 1, yn = 1.5, ut = 0.5, Vr = 1.75, Xr = 0.98, Kr = 0.25;
function ft(t) {
  if (typeof t > "u")
    return O;
  let i = t.primaryColor ?? null;
  i !== null && !hn(i) && (console.error("Authentic Core error: Invalid hex color (overriding primary theme color).", i), i = null);
  let o = t.secondaryColor ?? null;
  return o !== null && !hn(o) && (console.error("Authentic Core error: Invalid hex color (overriding secondary theme color).", o), o = null), {
    ...O,
    ...typeof t.useDarkMode < "u" ? { isDarkMode: t.useDarkMode } : {},
    get palette() {
      return {
        ...O.palette,
        ...i !== null ? {
          primary: i,
          doesPrimaryPassAccessibility: this.isDarkMode ? !L(i) : L(i),
          primaryContrast: w[L(i) ? "white" : "black"],
          // If no secondary color is provided, use the primary color.
          get secondary() {
            return this.primary;
          },
          get doesSecondaryPassAccessibility() {
            return this.doesPrimaryPassAccessibility;
          },
          get secondaryContrast() {
            return this.primaryContrast;
          }
        } : {},
        ...o !== null ? {
          secondary: o,
          doesSecondaryPassAccessibility: this.isDarkMode ? !L(o) : L(o),
          secondaryContrast: w[L(o) ? "white" : "black"]
        } : {},
        background: w[this.isDarkMode ? "offBlack" : "offWhite"],
        text: w[this.isDarkMode ? "offWhite" : "offBlack"],
        subtle: w[this.isDarkMode ? "darkGray" : "lightGray"],
        surface: w[this.isDarkMode ? "black" : "white"]
      };
    },
    get border() {
      if (typeof t.borderRadiusPx > "u")
        return O.border;
      const s = this.element.maxBorderRadiusPx, c = Math.min(s, t.borderRadiusPx);
      return {
        ...O.border,
        radiusPx: {
          sm: Math.min(s, c / 2),
          base: c,
          lg: Math.min(s, c * 3),
          full: c * 100
        }
      };
    },
    get shadow() {
      return {
        ...O.shadow,
        focus: O.shadow.focus.replace(
          k(O.palette.primary, this.opacity.subtle),
          k(this.palette.primary, this.opacity.subtle)
        )
      };
    },
    ...typeof t.brand < "u" ? {
      brand: {
        ...O.brand,
        ...typeof t.brand.name < "u" ? { name: t.brand.name } : {},
        ...typeof t.brand.logoUrls < "u" ? {
          logoUrls: {
            ...O.brand.logoUrls,
            ...typeof t.brand.logoUrls.darkBg < "u" ? { darkBg: t.brand.logoUrls.darkBg } : {},
            ...typeof t.brand.logoUrls.lightBg < "u" ? { lightBg: t.brand.logoUrls.lightBg } : {}
          }
        } : {},
        ...typeof t.brand.faviconUrl < "u" ? { faviconUrl: t.brand.faviconUrl } : {}
      }
    } : {}
  };
}
function st(t, i) {
  const o = {};
  function s(c) {
    return c === "start" || c === "end" ? `flex-${c}` : c;
  }
  if (typeof i.display < "u" && Object.assign(o, {
    display: i.display,
    alignItems: i.display === "flex" ? "flex-start" : void 0,
    justifyContent: i.display === "flex" ? "flex-start" : void 0,
    flexDirection: i.display === "flex" ? "row" : void 0
  }), i.inline === !0 && Object.assign(o, {
    display: `inline${typeof o.display < "u" ? `-${o.display}` : ""}`
  }), i.centered === !0 && Object.assign(o, { justifyContent: "center", alignItems: "center" }), typeof i.align < "u" && Object.assign(o, { alignItems: s(i.align) }), typeof i.alignSelf < "u" && Object.assign(o, { alignSelf: s(i.alignSelf) }), typeof i.justify < "u" && Object.assign(o, { justifyContent: s(i.justify) }), typeof i.justifySelf < "u" && Object.assign(o, { justifySelf: s(i.justifySelf) }), i.column === !0 && Object.assign(o, { flexDirection: "column" }), i.reverse === !0 && Object.assign(o, { flexDirection: `${o.flexDirection}-reverse` }), i.wrap === !0 && Object.assign(o, { flexWrap: "wrap" }), typeof i.shrink < "u" && Object.assign(o, { flexShrink: i.shrink ? 1 : 0 }), typeof i.gridArea < "u" && Object.assign(o, { gridArea: i.gridArea }), typeof i.gridTemplateRows < "u" && Object.assign(o, { gridTemplateRows: i.gridTemplateRows }), typeof i.gridTemplateColumns < "u" && Object.assign(o, { gridTemplateColumns: i.gridTemplateColumns }), typeof i.position < "u" && Object.assign(o, { position: i.position }), typeof i.top < "u" && Object.assign(o, {
    top: typeof i.top == "string" ? i.top : `${t.baseSpacingPx * i.top}px`,
    transform: i.top === "50%" ? "translateY(-50%)" : void 0
  }), typeof i.right < "u" && Object.assign(o, {
    right: typeof i.right == "string" ? i.right : `${t.baseSpacingPx * i.right}px`,
    transform: i.right === "50%" ? i.top === "50%" ? "translate(50%, -50%)" : "translateX(50%)" : o.transform
  }), typeof i.bottom < "u" && Object.assign(o, {
    bottom: typeof i.bottom == "string" ? i.bottom : `${t.baseSpacingPx * i.bottom}px`,
    transform: i.bottom === "50%" ? i.left === "50%" ? "translate(50%, 50%)" : i.right === "50%" ? "translate(-50%, 50%)" : "translateY(50%)" : o.transform
  }), typeof i.left < "u" && Object.assign(o, {
    left: typeof i.left == "string" ? i.left : `${t.baseSpacingPx * i.left}px`,
    transform: i.left === "50%" ? i.top === "50%" ? "translate(-50%, -50%)" : i.bottom === "50%" ? "translate(-50%, 50%)" : "translateX(-50%)" : o.transform
  }), typeof i.minW < "u" && Object.assign(o, { minWidth: i.minW }), typeof i.w < "u" && Object.assign(o, { width: i.w }), typeof i.maxW < "u" && Object.assign(o, {
    maxWidth: i.maxW === "view-content" ? `${t.view.maxContentWidthPx}px` : i.maxW === "element" ? `${t.element.maxWidthPx}px` : i.maxW
  }), typeof i.minH < "u" && Object.assign(o, { minHeight: i.minH }), typeof i.h < "u" && Object.assign(o, { height: i.h }), typeof i.maxH < "u" && Object.assign(o, { maxHeight: i.maxH }), typeof i.m < "u" && Object.assign(o, { margin: `${t.baseSpacingPx * i.m}px` }), typeof i.mx < "u") {
    const c = i.mx === "auto" ? "auto" : `${t.baseSpacingPx * i.mx}px`;
    Object.assign(o, { marginLeft: c, marginRight: c });
  }
  if (typeof i.my < "u") {
    const c = i.my === "auto" ? "auto" : `${t.baseSpacingPx * i.my}px`;
    Object.assign(o, { marginTop: c, marginBottom: c });
  }
  if (typeof i.mt < "u" && Object.assign(o, { marginTop: `${t.baseSpacingPx * i.mt}px` }), typeof i.mr < "u" && Object.assign(o, { marginRight: `${t.baseSpacingPx * i.mr}px` }), typeof i.mb < "u" && Object.assign(o, { marginBottom: `${t.baseSpacingPx * i.mb}px` }), typeof i.ml < "u" && Object.assign(o, { marginLeft: `${t.baseSpacingPx * i.ml}px` }), typeof i.p < "u") {
    const c = `${t.baseSpacingPx * i.p}px`;
    Object.assign(o, { paddingTop: c, paddingRight: c, paddingBottom: c, paddingLeft: c });
  }
  if (typeof i.px < "u") {
    const c = `${t.baseSpacingPx * i.px}px`;
    Object.assign(o, { paddingLeft: c, paddingRight: c });
  }
  if (typeof i.py < "u") {
    const c = `${t.baseSpacingPx * i.py}px`;
    Object.assign(o, { paddingTop: c, paddingBottom: c });
  }
  if (typeof i.pt < "u" && Object.assign(o, { paddingTop: `${t.baseSpacingPx * i.pt}px` }), typeof i.pr < "u" && Object.assign(o, { paddingRight: `${t.baseSpacingPx * i.pr}px` }), typeof i.pb < "u" && Object.assign(o, { paddingBottom: `${t.baseSpacingPx * i.pb}px` }), typeof i.pl < "u" && Object.assign(o, { paddingLeft: `${t.baseSpacingPx * i.pl}px` }), typeof i.bg < "u" && Object.assign(o, {
    backgroundColor: i.bg === "inherit" ? "inherit" : t.palette[i.bg]
  }), i.darkenBg === !0) {
    const c = zr * (t.isDarkMode ? 1.5 : 1);
    Object.assign(o, {
      backgroundColor: typeof o.backgroundColor < "u" ? Mr(o.backgroundColor, c) : k(w.black, c)
    });
  }
  if (i.lightenBg === !0 && Object.assign(o, {
    backgroundColor: typeof o.backgroundColor < "u" ? Ur(o.backgroundColor, En) : k(w.white, En)
  }), typeof i.c < "u" && Object.assign(o, { color: i.c === "inherit" ? "inherit" : t.palette[i.c] }), typeof i.fontFamily < "u" && Object.assign(o, { fontFamily: t.font.family[i.fontFamily] }), typeof i.lineHeight < "u" && Object.assign(o, {
    lineHeight: i.lineHeight === "inherit" ? "inherit" : i.lineHeight === 1 ? 1 : t.font.lineHeight[i.lineHeight]
  }), typeof i.fontSize < "u" && Object.assign(o, {
    fontSize: i.fontSize === "inherit" ? "inherit" : typeof i.fontSize == "number" ? t.font.sizePx.base * i.fontSize : t.font.sizePx[i.fontSize] + "px"
  }), typeof i.fontWeight < "u" && Object.assign(o, { fontWeight: i.fontWeight }), i.italic === !0 && Object.assign(o, { fontStyle: "italic" }), i.underline === !0 && Object.assign(o, { textDecoration: "underline" }), i.strikethrough === !0 && Object.assign(o, { textDecoration: "line-through" }), typeof i.textWrap < "u" && Object.assign(o, { textWrap: i.textWrap }), typeof i.textAlign < "u" && Object.assign(o, { textAlign: i.textAlign }), typeof i.border < "u" && Object.assign(o, {
    borderWidth: `${t.border.baseWidthPx}px`,
    borderStyle: "solid",
    borderColor: i.border === "inherit" ? "inherit" : i.border === "transparent" ? "transparent" : t.palette[i.border]
  }), typeof i.borderTop < "u" && Object.assign(o, {
    borderTopWidth: `${t.border.baseWidthPx}px`,
    borderTopStyle: "solid",
    borderTopColor: i.borderTop === "inherit" ? "inherit" : i.borderTop === "transparent" ? "transparent" : t.palette[i.borderTop]
  }), typeof i.borderRight < "u" && Object.assign(o, {
    borderRightWidth: `${t.border.baseWidthPx}px`,
    borderRightStyle: "solid",
    borderRightColor: i.borderRight === "inherit" ? "inherit" : i.borderRight === "transparent" ? "transparent" : t.palette[i.borderRight]
  }), typeof i.borderBottom < "u" && Object.assign(o, {
    borderBottomWidth: `${t.border.baseWidthPx}px`,
    borderBottomStyle: "solid",
    borderBottomColor: i.borderBottom === "inherit" ? "inherit" : i.borderBottom === "transparent" ? "transparent" : t.palette[i.borderBottom]
  }), typeof i.borderLeft < "u" && Object.assign(o, {
    borderLeftWidth: `${t.border.baseWidthPx}px`,
    borderLeftStyle: "solid",
    borderLeftColor: i.borderLeft === "inherit" ? "inherit" : i.borderLeft === "transparent" ? "transparent" : t.palette[i.borderLeft]
  }), typeof i.radius < "u" && Object.assign(o, { borderRadius: `${t.border.radiusPx[i.radius]}px` }), typeof i.topRightRadius < "u" && Object.assign(o, { borderTopRightRadius: `${t.border.radiusPx[i.topRightRadius]}px` }), typeof i.bottomRightRadius < "u" && Object.assign(o, { borderBottomRightRadius: `${t.border.radiusPx[i.bottomRightRadius]}px` }), typeof i.bottomLeftRadius < "u" && Object.assign(o, { borderBottomLeftRadius: `${t.border.radiusPx[i.bottomLeftRadius]}px` }), typeof i.topLeftRadius < "u" && Object.assign(o, { borderTopLeftRadius: `${t.border.radiusPx[i.topLeftRadius]}px` }), typeof i.shadow < "u" && Object.assign(o, { boxShadow: t.shadow[i.shadow] }), typeof i.opacity < "u" && Object.assign(o, { opacity: t.opacity[i.opacity] }), typeof i.filter < "u" && Object.assign(o, { filter: i.filter }), typeof i.transform < "u" && Object.assign(o, {
    transform: typeof o.transform < "u" ? `${o.transform} ${i.transform}` : i.transform
  }), typeof i.transformOrigin < "u" && Object.assign(o, { transformOrigin: i.transformOrigin }), i.transition === !0) {
    const c = t.transition.baseDurationMs * (i.transitionDuration ?? 1);
    Object.assign(o, {
      transitionProperty: "all",
      transitionDuration: c + "ms",
      transitionDelay: typeof i.transitionDelay < "u" ? `${c * i.transitionDelay}ms` : void 0,
      transitionTimingFunction: t.transition.timingFunction
    });
  }
  return typeof i.overflow < "u" && Object.assign(o, { overflow: i.overflow }), typeof i.overflowX < "u" && Object.assign(o, { overflowX: i.overflowX }), typeof i.overflowY < "u" && Object.assign(o, { overflowY: i.overflowY }), typeof i.cursor < "u" && Object.assign(o, { cursor: i.cursor }), typeof i.pointerEvents < "u" && Object.assign(o, {
    pointerEvents: i.pointerEvents,
    // Also prevent touch actions on mobile, like scrolling.
    touchAction: i.pointerEvents
  }), typeof i.zIndex < "u" && Object.assign(o, {
    zIndex: typeof i.zIndex == "string" ? t.element.zIndex[i.zIndex] : i.zIndex
  }), o;
}
function ct(t) {
  return {
    "dynamic-px": {
      px: xn,
      onMobile: { px: xn / 2 }
    },
    "dynamic-py": {
      py: Rn,
      onMobile: { py: Rn / 2 }
    },
    header: {
      display: "flex",
      align: "center",
      justify: "space-between",
      w: "100%"
    },
    card: {
      display: "flex",
      column: !0,
      w: "100%",
      maxW: "element",
      p: wn,
      bg: "surface",
      radius: t.border.radiusPx.base === t.element.maxBorderRadiusPx ? "base" : "lg",
      onMobile: { p: wn / 2 }
    },
    "disclaimer-text": {
      maxW: "285px",
      mt: 1.5,
      c: "muted",
      fontSize: "sm",
      textAlign: "center"
    }
  };
}
function dt(t, i) {
  return {
    fadeInWhen: (o) => ({
      opacity: o ? i.opacity : "hidden",
      transition: !0,
      pointerEvents: o ? i.pointerEvents : "none"
    }),
    moveDownWhen: (o) => {
      const s = `translateY(${t.baseSpacingPx * In}px)`;
      return {
        ...o ? {
          transform: typeof i.transform < "u" ? `${i.transform.split(" ").filter((c) => !c.includes("translateY")).join(" ")} ${s}` : s
        } : {},
        transition: !0,
        transitionDuration: yn
      };
    },
    moveUpWhen: (o) => {
      const s = `translateY(${t.baseSpacingPx * -In}px)`;
      return {
        ...o ? {
          transform: typeof i.transform < "u" ? `${i.transform.split(" ").filter((c) => !c.includes("translateY")).join(" ")} ${s}` : s
        } : {},
        transition: !0,
        transitionDuration: yn
      };
    },
    moveRightWhen: (o) => {
      const s = `translateX(${t.baseSpacingPx * bn}px)`;
      return {
        ...o ? {
          transform: typeof i.transform < "u" ? `${i.transform.split(" ").filter((c) => !c.includes("translateX")).join(" ")} ${s}` : s
        } : {},
        transition: !0,
        transitionDuration: Tn
      };
    },
    moveLeftWhen: (o) => {
      const s = `translateX(${t.baseSpacingPx * -bn}px)`;
      return {
        ...o ? {
          transform: typeof i.transform < "u" ? `${i.transform.split(" ").filter((c) => !c.includes("translateX")).join(" ")} ${s}` : s
        } : {},
        transition: !0,
        transitionDuration: Tn
      };
    },
    // Must also set the child container's `expandInnerWhen` transition.
    expandWhen: (o) => ({
      display: "grid",
      w: "100%",
      gridTemplateRows: (o ? 1 : 0) + "fr",
      transition: !0,
      transitionDuration: Vr,
      pointerEvents: o ? i.pointerEvents : "none"
    }),
    get expandInnerWhen() {
      return (o) => ({
        ...typeof i.opacity > "u" ? this.fadeInWhen(o) : {},
        w: "100%",
        px: i.px ?? i.p ?? 0.5,
        py: o ? i.py ?? i.p ?? 0.5 : void 0,
        overflow: "hidden"
      });
    },
    shrinkWhen: (o) => {
      const s = `scale(${Xr})`;
      return {
        ...o ? {
          transform: typeof i.transform < "u" ? `${i.transform} ${s}` : s
        } : {},
        transition: !0,
        transitionDuration: Kr
      };
    }
  };
}
function lt(t, i) {
  const o = i.isDarkMode ? "background" : "text", s = i.isDarkMode ? "text" : "surface";
  if (t in i.palette)
    return `${t}Contrast` in i.palette ? `${t}Contrast` : L(i.palette[t]) ? s : o;
  const c = t.startsWith("#") ? t : Or(t);
  return c === null ? (console.error("Authentic Core error: Invalid color (getting contrasting theme color).", t), o) : L(c) ? s : o;
}
function gt(t) {
  return `${t.brand.name}${t.brand.name.toLowerCase().includes("insurance") ? "" : " Insurance"}`;
}
const Jr = "https://demo.sandbox.authenticinsurance.com", pt = "widget_config", Pr = ["prefill_data", "data"], ht = "theme_overrides", At = "customer_id", _t = "estimate_id", Et = "application_id", xt = "document_id", Rt = "email", wt = "class_code", bt = "state_code", Zr = "rpv", Qr = "rpr", Tt = {
  version: 1,
  reward: {
    description: "Amazon gift card",
    value: 20
  },
  maxRewardsPerYear: 10,
  get termsAndConditionsUrl() {
    return `${v}/docs/authentic-referral-program-v${this.version}-terms-and-conditions.pdf`;
  }
};
function It(t = Jr, i = {}, o = {}) {
  return Nn(
    // @ts-expect-error - We know the first indexed pre-fill data URL param name exists.
    { [Pr[0]]: i, THEME_OVERRIDES_URL_PARAM_NAME: o },
    t
  );
}
function yt(t) {
  return t.toLowerCase().replaceAll(" ", "");
}
function mt(t, i, o) {
  return Nn(
    {
      [Zr]: `v${t.version}`,
      [Qr]: i
    },
    o
  );
}
typeof Object.hasOwn > "u" && Object.defineProperty(Object, "hasOwn", {
  value: (t, i) => Object.prototype.hasOwnProperty.call(t, i)
});
export {
  Et as APPLICATION_ID_URL_PARAM_NAME,
  Zi as AUTHENTIC_AGENT_CALENDLY_LINK,
  Qi as AUTHENTIC_AMTRUST_REFERRAL_LINK,
  zi as AUTHENTIC_BLOG_LINK,
  Sr as AUTHENTIC_BRAND_NAME,
  Wi as AUTHENTIC_BUSINESS_LEGAL_NAME,
  Ji as AUTHENTIC_CAREERS_LINK,
  et as AUTHENTIC_CLAIMS_EMAIL,
  ot as AUTHENTIC_CLAIMS_PHONE_NUMBER,
  Gr as AUTHENTIC_ENVIRONMENT,
  Xi as AUTHENTIC_GITBOOK_LINK,
  Vi as AUTHENTIC_GITHUB_LINK,
  Gi as AUTHENTIC_NPN_NUMBER,
  Si as AUTHENTIC_PARTNER_DEMO_LINK,
  nt as AUTHENTIC_PRIVACY_POLICY_URL,
  Pi as AUTHENTIC_SALES_CALENDLY_LINK,
  rt as AUTHENTIC_SALES_EMAIL,
  it as AUTHENTIC_SUPPORT_EMAIL,
  tt as AUTHENTIC_SUPPORT_PHONE_NUMBER,
  qi as AUTHENTIC_TERMS_OF_SERVICE_URL,
  Ki as AUTHENTIC_TWITTER_X_LINK,
  v as AUTHENTIC_WEBSITE_LINK,
  qn as BASE64_ENCODED_EMPTY_OBJECT,
  wt as BUSINESS_CLASS_CODE_URL_PARAM_NAME,
  wn as CARD_THEME_STYLE_P_PROP,
  wi as COUNTRIES,
  Rr as DAYS_OF_WEEK,
  xr as DAYS_PER_YEAR,
  Jr as DEFAULT_INSURANCE_PORTAL_URL,
  xt as DOCUMENT_ID_URL_PARAM_NAME,
  xn as DYNAMIC_THEME_STYLE_PX_PROP,
  Rn as DYNAMIC_THEME_STYLE_PY_PROP,
  Rt as EMAIL_URL_PARAM_NAME,
  _t as ESTIMATE_ID_URL_PARAM_NAME,
  Vr as EXPAND_TRANSITION_THEME_STYLE_DURATION_PROP,
  Ii as FORMATTED_DATE_STRING_LENGTH,
  Y as HEXADECIMAL_ENCODING_RADIX,
  Qn as HEXATRIDECIMAL_ENCODING_RADIX,
  _r as HOURS_PER_DAY,
  sr as INVALID_NAME_CHARSET_REGEX,
  Er as MAX_DAYS_PER_MONTH,
  ar as MAX_EMAIL_CHARS,
  Ar as MINS_PER_HOUR,
  gi as MONTHS_OF_YEAR,
  bn as MOVE_X_TRANSITION_BASE_SPACING_FACTOR,
  at as MOVE_X_TRANSITION_THEME_STYLE_DELAY_PROP,
  Tn as MOVE_X_TRANSITION_THEME_STYLE_DURATION_PROP,
  In as MOVE_Y_TRANSITION_BASE_SPACING_FACTOR,
  ut as MOVE_Y_TRANSITION_THEME_STYLE_DELAY_PROP,
  yn as MOVE_Y_TRANSITION_THEME_STYLE_DURATION_PROP,
  X as MS_PER_SECOND,
  ur as NUM_PHONE_NUMBER_DIGITS,
  Pr as PREFILL_DATA_URL_PARAM_NAMES,
  Ui as PURE_BLACK_COLOR_HEX,
  Oi as PURE_WHITE_COLOR_HEX,
  Qr as REFERRAL_PROGRAM_REFERRER_URL_PARAM_NAME,
  Tt as REFERRAL_PROGRAM_V1,
  Zr as REFERRAL_PROGRAM_VERSION_URL_PARAM_NAME,
  H as SECS_PER_MINUTE,
  Xr as SHRINK_TRANSITION_ELEMENT_SCALING_FACTOR,
  Kr as SHRINK_TRANSITION_THEME_STYLE_DURATION_PROP,
  bi as STATES,
  bt as STATE_CODE_URL_PARAM_NAME,
  At as TENANT_CUSTOMER_ID_URL_PARAM_NAME,
  ht as THEME_OVERRIDES_URL_PARAM_NAME,
  Fi as UTM_CAMPAIGN_URL_PARAM_NAME,
  Bi as UTM_CONTENT_URL_PARAM_NAME,
  Di as UTM_MEDIUM_URL_PARAM_NAME,
  Li as UTM_SOURCE_URL_PARAM_NAME,
  pt as WIDGET_CONFIG_URL_PARAM_NAME,
  ui as abbreviate,
  Un as arraysAreIdentical,
  li as bankAccountNumberIsValid,
  di as bankRoutingNumberIsValid,
  Yi as browserStorage,
  ri as capitalizeFirstLetter,
  L as colorIsDark,
  Mr as darkenColor,
  _i as dateIsInFuture,
  pr as dateIsValid,
  er as deepSpreadObjects,
  $i as elementWasClicked,
  si as emailIsValid,
  Hi as fileToBase64,
  mi as formatAddress,
  Ci as formatCurrency,
  yi as formatDate,
  Mi as formatPhoneNumber,
  ni as generateRandomBoolean,
  ji as generateRandomElementId,
  Ni as generateRandomHexColor,
  mn as generateRandomNumber,
  It as getEncodedInsurancePortalUrl,
  ai as getEndingSubtring,
  pi as getMidnightDate,
  fi as getMostCommonProperty,
  hi as getOffsetDate,
  mt as getReferralLink,
  xi as getRelativeDateLabel,
  qr as getRoundedNumber,
  yt as getTenantNameFromBrandName,
  ft as getTheme,
  gt as getThemeBrandNameWithInsurance,
  lt as getThemeContrastingColor,
  ct as getThemeStyleClasses,
  dt as getThemeStyleTransitions,
  st as getThemeStyles,
  Ei as getTimeOfDayLabel,
  Ai as getTimezoneAwareIsoString,
  vi as getUrlParam,
  hn as hexColorIsValid,
  k as hexToRgba,
  ki as isTextElement,
  Ur as lightenColor,
  ci as nameIsValid,
  tr as objectContainsSomeValue,
  Mn as objectsAreIdentical,
  Ti as parseAddress,
  Ri as pause,
  hr as phoneNumberIsValid,
  Wr as removeUrlParams,
  Or as rgbToHex,
  Nn as setUrlParams,
  ti as singularToPlural,
  ei as substringShouldBeCapitalized,
  nr as toCamelCase,
  ir as toKebabCase,
  rr as toSnakeCase,
  ii as toTitleCase,
  oi as truncateMiddle,
  q as urlIsValid,
  $ as valueIsObject,
  An as zipCodeIsValid
};
//# sourceMappingURL=index.js.map
